import './Textblock.scss';

import { Link } from 'react-router-dom';
import classNames from 'classnames';
import ipadReadBottom from '../../../assets/images/bottom-bar-ipad-read.png';
import ipadTop from '../../../assets/images/top-ipad.png';
import useWindowDimensions from '../../../hooks/useWindowDimensions';

const Textblock = ({
    id,
    title,
    h = 2,
    text,
    image,
    links,
    revert,
    imgSize,
    imgLink,
    imgAlt,
    margin = 8,
    screen = false,
}) => {
    const { viewWidth } = useWindowDimensions();

    const textblockClass = classNames('Textblock', `my${margin}`),
        rowClass = classNames('row d-flex', {
            revert: revert,
        }),
        imageSize = viewWidth < 768 ? 100 : imgSize,
        textSize = !image || viewWidth < 768 ? 100 : 100 - imgSize,
        Elem = `h${h}`,
        headingClass = classNames('heading mb2', {
            'heading--medium': h === 2,
            'heading--small': h === 3,
        }),
        imageColClass = classNames('col image-col', {
            ipad: screen,
        });

    return (
        <section id={id} className={textblockClass}>
            <div className="container text--left">
                <div className={rowClass}>
                    <div
                        className="col text-col"
                        style={{ width: textSize + '%' }}
                    >
                        <Elem className={headingClass}>{title}</Elem>
                        <p className="text">{text}</p>
                        {links &&
                            links.map(link => {
                                return (
                                    <>
                                        <Link
                                            className="text arrow mt2 d-inline-block"
                                            to={link.url}
                                            target="blank"
                                        >
                                            {link.label}
                                            <svg
                                                className="svg-arrow"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M11.9571 2.55078L19.3308 9.92455L11.9571 17.2984L10.5429 15.8842L15.5024 10.9246H2.49994V8.92455H15.5024L10.5429 3.96499L11.9571 2.55078Z"
                                                />
                                            </svg>
                                        </Link>
                                        <br />
                                    </>
                                );
                            })}
                    </div>
                    {image && (
                        <div
                            className={imageColClass}
                            style={{ width: imageSize + '%' }}
                        >
                            {screen && (
                                <img
                                    className="top-bar img-responsive"
                                    src={ipadTop}
                                    alt="top bar van de ipad"
                                />
                            )}
                            {imgLink ? (
                                <Link
                                    className="img-link"
                                    to={imgLink}
                                    target="blank"
                                >
                                    <img
                                        className="img-responsive"
                                        src={image}
                                        alt={imgAlt}
                                    />
                                </Link>
                            ) : (
                                <img
                                    className="img-responsive"
                                    src={image}
                                    alt={imgAlt}
                                />
                            )}
                            {screen && (
                                <img
                                    className="bottom-bar img-responsive"
                                    src={ipadReadBottom}
                                    alt="bottom bar van de ipad"
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Textblock;
